export default __webpack_public_path__ + "static/14-d7b99186e98e13905cc201b0a3fff676.webp";